import {Checkout, CheckoutConstructor} from '../interfaces';

declare global {
    interface Window {
        cp?: {
            Checkout?: CheckoutConstructor;
        }
    }
}

export type LoadCheckout = Promise<CheckoutConstructor>;

let checkoutPromise: LoadCheckout | null = null;
const URL = 'https://checkout.cloudpayments.ru/checkout.js';
const URL_REGEX = /^https:\/\/checkout\.cloudpayments\.ru\/checkout\.js\/?(\?.*)?$/;

function findScript(): HTMLScriptElement | null {
    const scripts = document.querySelectorAll<HTMLScriptElement>(
        `script[src^="${URL}"]`
    );

    for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];

        if (URL_REGEX.test(script.src)) {
            return script;
        }
    }

    return null;
}

function injectScript(url?: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.src = url ?? `${URL}`;

    const headOrBody = document.head || document.body;

    if (!headOrBody) {
        throw new Error(
            'body not to be null'
        );
    }

    headOrBody.appendChild(script);

    return script;
}

export function loadScript(url?: string): LoadCheckout {

    if (checkoutPromise !== null) {
        return checkoutPromise;
    }

    checkoutPromise = new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            reject('allow to call only in browser');
            return;
        }

        if (window.cp?.Checkout) {
            resolve(window.cp?.Checkout);
        }

        try {
            let script = findScript();

            if (!script) {
                script = injectScript(url);
            }

            script.addEventListener('load', () => {

                if (window.cp?.Checkout) {
                    resolve(window.cp?.Checkout);
                } else {
                    reject(new Error('window.cp.Checkout not found after loading'));
                }
            });

            script.addEventListener('error', (err) => {
                reject(new Error(`Failed to load checkout: ${err.message}`));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });

    return checkoutPromise;
}